import { MessageBox, Message } from 'element-ui'
import common from '@/utils/common.js'


//鉴权并提示；
async function check(AtA){
	if(window.sessionStorage.getItem('lenovo')===''||window.sessionStorage.getItem('lenovo')===null){
        Message.error('非法操作');
        common.logout();
    }
    if(window.sessionStorage.getItem('Hasee')===''||window.sessionStorage.getItem('Hasee')===null){
        Message.error('非法操作');
        common.logout();
    }

    const AccountType = common.GetUserRole();
    if(AccountType==='root') return true;

    const Permission = await common.GetSystemRole();
    if(Permission.indexOf(AtA) === -1){
        Message.error('对不起，您暂无权限！');
        return false;
    }
    return true;
}


//鉴权不提示；
async function checkOf(AtA){
    if(window.sessionStorage.getItem('lenovo')===''||window.sessionStorage.getItem('lenovo')===null){
        Message.error('非法操作');
        common.logout();
    }
    if(window.sessionStorage.getItem('Hasee')===''||window.sessionStorage.getItem('Hasee')===null){
        Message.error('非法操作');
        common.logout();
    }
    const AccountType = common.GetUserRole();
    if(AccountType==='root') return true;

    const Permission = await common.GetSystemRole();
    if(Permission.indexOf(AtA)===-1){
        return false;
    }
    return true;
}

export default {
	check,
    checkOf
}